"use client";

import { useEffect } from "react";

import { type HomeHeroCopyVariant } from "@/lib/marketing-experiment";
import { syncMarketingExperimentBootstrap } from "@/lib/marketing-analytics-client";

type HomeHeroExperimentSyncProps = {
  homeHeroVariant: HomeHeroCopyVariant | null;
};

export function HomeHeroExperimentSync({
  homeHeroVariant,
}: HomeHeroExperimentSyncProps) {
  useEffect(() => {
    syncMarketingExperimentBootstrap({
      homeHeroVariant,
    });
  }, [homeHeroVariant]);

  return null;
}
